import React from 'react';
import './ForgotPasswordPage.css';
import { Navbar, Page } from 'framework7-react';
import Content from '../../helpers/content/Content';
import Input from '../../input/Input';
import FormTemplate from '../../templates/formTemplates/FormTemplate';
import Button from '../../button/Button';
import mainAPI from '../../../api/MainAPI';
import toasts from '../../../utils/toasts';
import Label from "../../label/Label";

export default class ForgotPasswordPage extends FormTemplate {
	_send = async () => {
		let value = this.getValue();
		const email = value.email.trim();
		let userStatus = await mainAPI.user.loginStatus({ username: email });
		if (userStatus?.inactive_after_date) {
			return toasts.error('Your account has been disabled. Please contact your agency admin if this is a mistake', 2500);
		}
		if(!email.includes('@')){
			return toasts.error(`Enter a valid email (${email})`)
		}
		await mainAPI.user.forgot_password({ email });
		toasts.show('Check your email', 10000);
		window.location.hash = '';
		window.f7.views.login.router.back();
		if(this.props.onComplete){
			this.props.onComplete();
		}
		// window.popupController.hide(ResetPasswordPopup);
		if(window.f7.views.reset_password){
			window.f7.views.reset_password.router.back();
		}
	};

	render() {
		const mode = this.props.mode || 'Reset';
		const optionalProps = {backLink:"Back"};
		if(this.props.noBackLink){
			optionalProps.backLink = false;
		}
		return (
			<Page className="g-forgot-password-page">
				<Navbar title={`${mode} Password`} {...optionalProps}></Navbar>
				<Content>
					<div className="label">Enter your email</div>
					<Input border className="border" onEnter={this._send} value={this.props.email} ref={(ref) => (this.myRefs.email = ref)} />
				</Content>
				<Content>
					<Label dark>
						We will send you an email with a link to set your password.
					</Label>
				</Content>
				<Button className={'bottom-button'} bg="blue" color="white" onClick={this._send} center>
					Send {`${mode}`} Password Email
				</Button>
			</Page>
		);
	}
}
